import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import TransformationMapper from "./mappers/TransformationMapper";
import DataTableReadMapper from "./mappers/DataTableReadMapper";
import GroupFilterMapper from "./mappers/GroupFilterMapper";

import DataTableReadDto from "../classes/dtos/pathcommonmodule/DataTableReadDto";

import GetPathMetaApiDetailResult from "../classes/api/result/pathmetaapimodule/GetPathMetaApiDetailResult";
import UpdatePathMetaApiDetailResult from "../classes/api/result/pathmetaapimodule/UpdatePathMetaApiDetailResult";

import GetPathMetaApiCapabilitiesResult from "../classes/api/result/pathmetaapimodule/GetPathMetaApiCapabilitiesResult";

import PathMetaApiMappingDto from "../classes/dtos/pathmetaapimodule/PathMetaApiMappingDto";
import ScheduleDto from "../classes/dtos/schedulermodule/ScheduleDto";

import FieldReferenceIdAndKeyDto from "../classes/dtos/FieldReferenceIdAndKeyDto";
import FieldTypeReferenceDto from "../classes/dtos/FieldTypeReferenceDto";
import PathMetaApiMappingCapabilitiesDto from "../classes/dtos/pathmetaapimodule/PathMetaApiMappingCapabilitiesDto";

const PathMetaApiApi = {

    GetPathMetaApiDetailAsync: async function (pathId: number): Promise<ProcessingResult<GetPathMetaApiDetailResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/PathMetaApi/GetPathMetaApiDetail?pathId=" + pathId.toString(), {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            let source = DataTableReadMapper.ToDto(data.source);
            let mappings = data.mappings.map((e: any) => new PathMetaApiMappingDto(e.fieldReferenceId, e.transformationLogicId, e.transformationParameters, e.technicalName, e.isSelected, GroupFilterMapper.RowFiltersToDtos(e.filters), GroupFilterMapper.DeclaredVariablesFromResponse(e.declaredVariables)));
            let schedule = new ScheduleDto(data.schedule.isActive, data.schedule.scheduleType, data.schedule.interval, data.schedule.time);
            return ProcessingResult.Ok(new GetPathMetaApiDetailResult(data.id, data.name, source, mappings, schedule, data.lastVersionId, data.publishedVersionId, data.advancedFilterMode ?? false));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    UpdatePathMetaApiDetailAsync: async function (pathId: number, name: string, mappings: PathMetaApiMappingDto[], source: DataTableReadDto, schedule: ScheduleDto, advancedFilterMode: boolean, publish: boolean): Promise<ProcessingResult<UpdatePathMetaApiDetailResult>> {
        let authSession = await AuthToken.get();

        let time = (schedule.Time / (60 * 1000)) - new Date().getTimezoneOffset();

        const response = await fetch(Settings.api_url + "/PathMetaApi/UpdatePathMetaApiDetail", {
            method: "Post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'pathId': pathId,
                'name': name,
                'source': DataTableReadMapper.ToPayload(source),
                'mappings': mappings.map((e) => ({ fieldReferenceId: e.FieldReferenceId, transformationLogicId: e.TransformationLogicId, transformationParameters: e.TransformationParameters, technicalName: e.TechnicalName, isSelected: e.IsSelected, filters: GroupFilterMapper.RowFiltersToPayload(e.Filters), declaredVariables: GroupFilterMapper.DeclaredVariablesToPayload(e.DeclaredVariables) })),
                'schedule': {
                    'isActive': schedule.IsActive,
                    'scheduleType': schedule.Type,
                    'interval': schedule.Interval,
                    'time': time
                },
                'advancedFilterMode': advancedFilterMode,
                'Publish': publish
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new UpdatePathMetaApiDetailResult(data.id, data.isPublished));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    GetPathMetaApiCapabilitiesAsync: async function (tableReferenceSourceId: number | null, pathId: number | null): Promise<ProcessingResult<GetPathMetaApiCapabilitiesResult>> {
        let authSession = await AuthToken.get();

        let url = "/PathMetaApi/GetPathMetaApiCapabilities";
        let separator = "?";

        if (tableReferenceSourceId !== null) { url = url + separator + "TableReferenceSourceId=" + tableReferenceSourceId; separator = "&"; }
        if (pathId !== null) { url = url + separator + "PathId=" + pathId; }

        const response = await fetch(Settings.api_url + url, {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            let sourceFields = data.sourceFields.map((e: any) => new FieldReferenceIdAndKeyDto(e.id, e.sourceKey, e.datasetKey, e.name, new FieldTypeReferenceDto(e.type.type, e.type.isMultiple, e.type.typeLabel, e.type.isNullable, e.type.maxLength, e.type.isReadOnly, e.type.isCalculated, e.type.isBusinessRequired, e.type.isPrimaryKey, e.type.originTypeLabel, e.type.linkTableId)));
            let mappingsCapabilities = data.mappingsCapabilities.map((e: any) => new PathMetaApiMappingCapabilitiesDto(e.sourceFieldId, e.transformationLogicIds));
            let transformationsCapabilities = data.transformationsCapabilities.map((e: any) => TransformationMapper.ToDto(e));
            return ProcessingResult.Ok(new GetPathMetaApiCapabilitiesResult(sourceFields, mappingsCapabilities, transformationsCapabilities));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default PathMetaApiApi;